import React from 'react';
import { Page, UiAccordion, UiAddToSlackSection, UiBlock, UiButton, UiCaption, UiCard, UiCarousel, UiColumn, UiCookieBanner, UiCookiePreferences, UiDownloadButton, UiEmailSignup, UiFeatureComparisonTable, UiFooter, UiHeader, UiImage, UiImageList, UiLink, UiLinkBlock, UiListCarousel, UiLoginContainer, UiMarkdown, UiMarketoForm, UiModal, UiNavImages, UiPlaceholder, UiPowerUp, UiPriceCard, UiPricingCalculator, UiPricingGrid, UiPricingTable, UiRecommendShare, UiRotatingItems, UiSection, UiSocialShare, UiStack, UiStoryline, UiTechDemo, UiTemplateGallery, UiTextBlock, UiTooltip, UiTrelloBoard, UiValueProp, UiVideo, UiVideoPlayer, UiWebinarLink } from './views';
/**
 * TODO: view models should be rendered automatically by the framework
 */
export function renderViewModel(viewModel) {
    switch (viewModel.type) {
        case 'page':
            return React.createElement(Page, { key: viewModel.id, model: viewModel });
        case 'uiAccordion':
            return React.createElement(UiAccordion, { key: viewModel.id, model: viewModel });
        case 'uiAddToSlackSection':
            return React.createElement(UiAddToSlackSection, { key: viewModel.id, model: viewModel });
        case 'uiBlock':
            return React.createElement(UiBlock, { key: viewModel.id, model: viewModel });
        case 'uiButton':
            return React.createElement(UiButton, { key: viewModel.id, model: viewModel });
        case 'uiCaption':
            return React.createElement(UiCaption, { key: viewModel.id, model: viewModel });
        case 'uiCard':
            return React.createElement(UiCard, { key: viewModel.id, model: viewModel });
        case 'uiCarousel':
            return React.createElement(UiCarousel, { key: viewModel.id, model: viewModel });
        case 'uiColumn':
            return React.createElement(UiColumn, { key: viewModel.id, model: viewModel });
        case 'uiCookieBanner':
            return React.createElement(UiCookieBanner, { key: viewModel.id, model: viewModel });
        case 'uiCookiePreferences':
            return React.createElement(UiCookiePreferences, { key: viewModel.id, model: viewModel });
        case 'uiDownloadButton':
            return React.createElement(UiDownloadButton, { key: viewModel.id, model: viewModel });
        case 'uiEmailSignup':
            return React.createElement(UiEmailSignup, { key: viewModel.id, model: viewModel });
        case 'uiFeatureComparisonTable':
            return React.createElement(UiFeatureComparisonTable, { key: viewModel.id, model: viewModel });
        case 'uiFooter':
            return React.createElement(UiFooter, { key: viewModel.id, model: viewModel });
        case 'uiHeader':
            return React.createElement(UiHeader, { key: viewModel.id, model: viewModel });
        case 'uiImageList':
            return React.createElement(UiImageList, { key: viewModel.id, model: viewModel });
        case 'uiImage':
            return React.createElement(UiImage, { key: viewModel.id, model: viewModel });
        case 'uiLoginContainer':
            return React.createElement(UiLoginContainer, { key: viewModel.id, model: viewModel });
        case 'uiLink':
            return React.createElement(UiLink, { key: viewModel.id, model: viewModel });
        case 'uiLinkBlock':
            return React.createElement(UiLinkBlock, { key: viewModel.id, model: viewModel });
        case 'uiListCarousel':
            return React.createElement(UiListCarousel, { key: viewModel.id, model: viewModel });
        case 'uiMarkdown':
            return React.createElement(UiMarkdown, { key: viewModel.id, model: viewModel });
        case 'uiMarketoForm':
            return React.createElement(UiMarketoForm, { key: viewModel.id, model: viewModel });
        case 'uiModal':
            return React.createElement(UiModal, { key: viewModel.id, model: viewModel });
        case 'uiNavImages':
            return React.createElement(UiNavImages, { key: viewModel.id, model: viewModel });
        case 'uiPlaceholder':
            return React.createElement(UiPlaceholder, { key: viewModel.id, model: viewModel });
        case 'uiPowerUp':
            return React.createElement(UiPowerUp, { key: viewModel.id, model: viewModel });
        case 'uiPriceCard':
            return React.createElement(UiPriceCard, { key: viewModel.id, model: viewModel });
        case 'uiPricingCalculator':
            return React.createElement(UiPricingCalculator, { key: viewModel.id, model: viewModel });
        case 'uiPricingGrid':
            return React.createElement(UiPricingGrid, { key: viewModel.id, model: viewModel });
        case 'uiPricingTable':
            return React.createElement(UiPricingTable, { key: viewModel.id, model: viewModel });
        case 'uiRecommendShare':
            return React.createElement(UiRecommendShare, { key: viewModel.id, model: viewModel });
        case 'uiRotatingItems':
            return React.createElement(UiRotatingItems, { key: viewModel.id, model: viewModel });
        case 'uiSection':
            return React.createElement(UiSection, { key: viewModel.id, model: viewModel });
        case 'uiSocialShare':
            return React.createElement(UiSocialShare, { key: viewModel.id, model: viewModel });
        case 'uiStack':
            return React.createElement(UiStack, { key: viewModel.id, model: viewModel });
        case 'uiStoryline':
            return React.createElement(UiStoryline, { key: viewModel.id, model: viewModel });
        case 'uiTechDemo':
            return React.createElement(UiTechDemo, { key: viewModel.id, model: viewModel });
        case 'uiTemplateGallery':
            return React.createElement(UiTemplateGallery, { key: viewModel.id, model: viewModel });
        case 'uiTextBlock':
            return React.createElement(UiTextBlock, { key: viewModel.id, model: viewModel });
        case 'uiTrelloBoard':
            return React.createElement(UiTrelloBoard, { key: viewModel.id, model: viewModel });
        case 'uiTooltip':
            return React.createElement(UiTooltip, { key: viewModel.id, model: viewModel });
        case 'uiValueProp':
            return React.createElement(UiValueProp, { key: viewModel.id, model: viewModel });
        case 'uiVideo':
            return React.createElement(UiVideo, { key: viewModel.id, model: viewModel });
        case 'uiVideoPlayer':
            return React.createElement(UiVideoPlayer, { key: viewModel.id, model: viewModel });
        case 'uiWebinarLink':
            return React.createElement(UiWebinarLink, { key: viewModel.id, model: viewModel });
        default:
            return React.createElement("div", { key: viewModel.id },
                "Unhandled block: ",
                viewModel.type);
    }
}
export function renderViewModels(viewModels) {
    return viewModels.map(renderViewModel);
}
//# sourceMappingURL=render-view-model.js.map